export default {
  get: {
    getCode: '/api/user/get-code',

    loginLog: '/api/user/login-log',

    getFp: '/api/user/get-fp',

    delDevice: '/api/user/del-fp',
    getCard: '/api/user/get-card',
    passportInfo: '/passport/info'
  },
  post: {
    uploadAvatar: '/api/user/upload-avatar',
    updatePhone: '/api/user/update-phone',
    checkCode: '/api/user/check-code',
    uploadCard: '/api/user/upload-card',
    //绑定passport获取验证码
    passportCode: '/passport/send-code',
    //绑定passport提交
    passportReg: '/passport/reg'
  }
}


